import { AssociatedCopy, SingleCopy } from "@/sx-layout/components/plotmap/models";

/**  "1": 重機＋立入禁止エリア */
export const ASSOCIATED_COPY: AssociatedCopy = "1";

/**  "2": 重機または立入禁止エリアのみ */
export const SINGLE_COPY: SingleCopy = "2";

export const MACHINE_ICON_SIZE = 40;
